import { Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { LoginService } from '../login-service/login.service';
import { environment } from '../../../environments/environment';
import { CyclingLoadingMessagesComponent } from '../cycling-loading-messages/cycling-loading-messages.component';
import { LoginFormComponent } from '../components/login-form/login-form.component';
import { SettingsService } from '../services/settings-service/settings.service';
import {
	UpdateStatusService,
	UpdateCheckStatus,
} from '../update-status-service/update-status.service';
import { Observable, of } from 'rxjs';

@Component({
	selector: 'app-login-screen',
	standalone: true,
	imports: [
		CommonModule,
		NgbModule,
		CyclingLoadingMessagesComponent,
		LoginFormComponent,
	],
	templateUrl: './login-screen.component.html',
	styleUrl: './login-screen.component.scss',
})
export class LoginScreenComponent implements OnInit {
	isLoggingIn = false;
	loginError = '';
	showLoginForm = false;

	// Service mode properties from environment
	isServiceMode = environment.serviceMode;
	serviceMessageTitle = environment.serviceMessageTitle;
	serviceMessageText = environment.serviceMessageText;

	settingsService = inject(SettingsService);

	// Update status service for showing service worker update check status
	private updateStatusService = inject(UpdateStatusService);
	updateCheckStatus$: Observable<UpdateCheckStatus> =
		this.updateStatusService.status$;

	constructor(private loginService: LoginService) {}

	ngOnInit() {
		// If in service mode, don't attempt login
		if (this.isServiceMode) {
			return;
		}

		// Check if environment variables are set
		if (environment.username && environment.password) {
			// Try automatic login
			this.attemptLogin(environment.username, environment.password);
		} else {
			// Show login form
			this.showLoginForm = true;
		}
	}

	getUpdateStatus(): Observable<UpdateCheckStatus> {
		return of('checking');
	}

	onLoginAttempt(credentials: { username: string; password: string }) {
		this.attemptLogin(credentials.username, credentials.password);
	}

	private attemptLogin(username: string, password: string) {
		this.isLoggingIn = true;
		this.loginError = '';

		this.loginService.Login(username, password).subscribe({
			next: (success) => {
				this.isLoggingIn = false;
				if (success) {
				} else {
					this.loginError =
						'Kirjautuminen epäonnistui. Tarkista kirjautumistunnukset.';
					this.showLoginForm = true;
				}
			},
			error: (error) => {
				this.isLoggingIn = false;
				this.loginError = 'Kirjautuminen epäonnistui.';
				this.showLoginForm = true;
			},
		});
	}
}
